import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBAutosizeTextInput } from '@shared/components/textInput';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MBBlockLabel } from '../../utils/label';
import { renderToggle } from '../input';

interface Props {
  enabled: boolean;
  name: string;
  onToggle(enabled: boolean): void;
  onChangeName(batchName: string): void;
}

export function BatchOptions({ enabled, name, onToggle, onChangeName }: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <View paddingBottom={2}>
      <View row centerVertically>
        <View flex paddingRight={4}>
          <MBBlockLabel label={i18n('card.blocks.assigneeInput.batchOptions.enable.title')} />
          <Text size="body2">
            {i18n('card.blocks.assigneeInput.batchOptions.enable.description')}
          </Text>
        </View>
        {renderToggle(enabled, onToggle)}
      </View>
      {enabled && (
        <View paddingTop={2}>
          <MBBlockLabel label={i18n('card.blocks.assigneeInput.batchOptions.name.title')} />
          <MBAutosizeTextInput
            style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
            onChangeText={onChangeName}
            value={name}
            placeholder={i18n('card.blocks.assigneeInput.batchOptions.name.placeholder')}
            autoFocus
            padding="normal"
          />
        </View>
      )}
    </View>
  );
}
